module.exports = __webpack_public_path__ + "5697625b25f597bc73687e07a30f6ac9.woff";


//////////////////
// WEBPACK FOOTER
// ./ClientApp/fonts/Avenir-Heavy.woff
// module id = 655
// module chunks = 0